import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-map",
  "use": "icon-map-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-map\" id=\"icon-map\"><polygon points=\"1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6\" /><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"18\" /><line x1=\"16\" y1=\"6\" x2=\"16\" y2=\"22\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol